import { useQuery } from 'react-query';

import { getAnalyticsSRBMHeatMapChart } from 'api/analitics/SrbmCharts/getAnalyticsSRBMHeatMapChart';

export const useGetAnalyticsSRBMHeatMapChartData = (
  slug: string,
  start_datetime: string,
  end_datetime: string,
  enabled?: { enabled: boolean },
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    'AnalyticsSRBMHeatMapChartData',
    () => getAnalyticsSRBMHeatMapChart(slug, start_datetime, end_datetime),
    {
      refetchOnWindowFocus: false,
      enabled: enabled?.enabled ?? true,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetAnalyticsSRBMHeatMapChartData;
